const listeners = new Set();

export function showGlobalToast(message, options = {}) {
  const payload = {
    id: Date.now(),
    message,
    durationMs: options.durationMs ?? 3000,
  };
  listeners.forEach((listener) => listener(payload));
}

export function subscribeToToasts(listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}
